'use client'

import { useLayoutEffect } from 'react'
import { suppressNativeGoogleOfferwall } from '@/lib/google-offerwall'

/** Install before banner effects; custom rewarded ads start only on user click. */
export default function GoogleOfferwallGuard() {
  useLayoutEffect(() => {
    suppressNativeGoogleOfferwall()
  }, [])
  return null
}
